import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpRequestMethods,
  LoggingService
} from '@com-delta-idp/mnx-utils';
import { Observable, throwError } from 'rxjs';
import { EndpointKeys, IDP_APPS } from '../constants/urls.constants';
import {
  UpdateSearchApiMultiCityPayload,
  UpdateSearchApiPayload
} from '../models/states/update-search-state.interfaces';
import { SBW_TIMEOUT } from '../constants/common.constants';

@Injectable({
  providedIn: 'root'
})
export class UpdateSearchApiService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private logging: LoggingService
  ) {}

  updateSearch(
    payload: UpdateSearchApiPayload | UpdateSearchApiMultiCityPayload,
    isTripTypeMultiCity: boolean
  ): Observable<unknown> {
    let url = EndpointKeys.UPDATE_SEARCH;
    let queryParams = '?searchType=RecentSearchesJSON';
    if (isTripTypeMultiCity) {
      url = EndpointKeys.SAVE_SLIM_NAV_DETAILS_URL;
      queryParams = '';
    }
    return new ApiBuilder<
      UpdateSearchApiPayload | UpdateSearchApiMultiCityPayload,
      unknown
    >(this.http, this.appConfig)
      .app(IDP_APPS.BOOK_WIDGET)
      .endpointKey(url)
      .queryParams(queryParams)
      .method(HttpRequestMethods.POST)
      .payload(payload)
      .timeOut(SBW_TIMEOUT.COMMON)
      .errorHandler(this._handleError.bind(this))
      .create();
  }

  private _handleError(error: HttpErrorResponse): Observable<never> {
    this.logging.log(error.message);
    return throwError(error);
  }
}
